/**
 * @generated SignedSource<<d3b278f19fc97cf2a3a73f730701ed5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTeamScheduleDisplayType = "DAILY" | "DAILY_WITH_SUMMARY" | "MONTHLY" | "WEEKLY";
export type CreateWidgetTeamScheduleInput = {
  positionX: number;
  positionY: number;
  roleIds?: ReadonlyArray<string> | null;
  size: WidgetOverviewSize;
  teamIds: ReadonlyArray<string>;
  title?: string | null;
  type?: WidgetTeamScheduleDisplayType | null;
  withoutRoleSelected?: boolean | null;
};
export type WATeamScheduleMutation$variables = {
  input: CreateWidgetTeamScheduleInput;
  storecastId: string;
};
export type WATeamScheduleMutation$data = {
  readonly dashboard: {
    readonly createWidgetTeamSchedule: {
      readonly id: string;
    };
  };
};
export type WATeamScheduleMutation = {
  response: WATeamScheduleMutation$data;
  variables: WATeamScheduleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetTeamSchedule",
        "kind": "LinkedField",
        "name": "createWidgetTeamSchedule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WATeamScheduleMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WATeamScheduleMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "eb778a96181c4c3de222057c4b2c872a",
    "id": null,
    "metadata": {},
    "name": "WATeamScheduleMutation",
    "operationKind": "mutation",
    "text": "mutation WATeamScheduleMutation(\n  $storecastId: ID!\n  $input: CreateWidgetTeamScheduleInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetTeamSchedule(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5680dafb2092aa55b11e7db46c5dae2";

export default node;
